import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as levenshtein from 'fast-levenshtein';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-districtwise-office-representative-bussiness',
  // standalone: true,
  // imports: [],
  templateUrl: './districtwise-office-representative-bussiness.component.html',
  styleUrl: './districtwise-office-representative-bussiness.component.scss'
})
export class DistrictwiseOfficeRepresentativeBussinessComponent {
datewisedata;
  today = new Date();
  startdate = '';
  enddate = '';
  datewiselist = [];
  tempdata = [];
  district: any;
  appliedFilters: any = {}; 

  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
   
  ];
  totalth = 0;
  finalData = [];
  state: any;
  country: any;

  constructor(
    private dialogref: MatDialogRef<DistrictwiseOfficeRepresentativeBussinessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    debugger
    this.isLoading = true;
    this.district = this.data.district
    this.datewisedata = this.data['data'];
    console.log(this.datewisedata, "first data")
    

    console.log(this.datewisedata, "statewise")
    this.startdate = this.data['startDate'];
    this.enddate = this.data['endDate'];
    // console.log(formatDate(new Date(), 'MMMM', 'en-IN', 'GMT+0530'));

    this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.datewisedata, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 3 + 3;

    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 4;

    // this.getDateORrepwiselist();
    this.setData();
  }

  getDistrictTotal(districtData: any[], key: string): number {
    return districtData.reduce((sum, office) => sum + (office[key] || 0), 0);
  }

  getDistrictSubtypeTotal(districtData: any[], subName: string, suffix: string): number {
    return districtData.reduce((sum, office) => sum + (office.subtype_totals?.[this.getKey(subName) + suffix] || 0), 0);
  }

  getTotal(data: any[], key: string): number {
    return data.reduce((sum, country) =>
      sum + country.datewiseData.reduce((s, state) =>
        s + state.datewiseData.reduce((dSum, district) =>
          dSum + district.datewiseData.reduce((oSum, office) => oSum + (office[key] || 0), 0), 0), 0), 0);
  }

  getTotalSubtype(data: any[], subName: string, suffix: string): number {
    return data.reduce((sum, country) =>
      sum + country.datewiseData.reduce((s, state) =>
        s + state.datewiseData.reduce((dSum, district) =>
          dSum + district.datewiseData.reduce((oSum, office) =>
            oSum + (office.subtype_totals?.[this.getKey(subName) + suffix] || 0), 0), 0), 0), 0);
  }

  soundex(s: string): string {
    return s
      .toUpperCase()
      .replace(/[^A-Z]/g, "") // Remove non-alphabet characters
      .split("")
      .map((char) => {
        if ("AEIOUHWY".includes(char)) return "0";
        if ("BFPV".includes(char)) return "1";
        if ("CGJKQSXZ".includes(char)) return "2";
        if ("DT".includes(char)) return "3";
        if ("L".includes(char)) return "4";
        if ("MN".includes(char)) return "5";
        if ("R".includes(char)) return "6";
        return char;
      })
      .join("")
      .replace(/0/g, "");
  }



setData() {
  const countryMap = this.datewisedata.reduce((acc, record) => {
    acc[record.country] ??= {};
    acc[record.country][record.state] ??= {};
    acc[record.country][record.state][record.district_name] ??= [];
    acc[record.country][record.state][record.district_name].push(record);
    return acc;
  }, {});

  let finalTotal: any = {};
  this.subTypesName.forEach((b: any, i) => {
    if (b.isVisible) {
      let name = this.getKey(b.name);
      finalTotal[name + '_एकूण'] = 0;
      finalTotal[name + '_नवीन'] = 0;
      finalTotal[name + '_नूतनीकरण'] = 0;
      if (i === 0) {
        finalTotal['name'] = 'एकूण';
        finalTotal['एकूण'] = 0;
        finalTotal['नवीन'] = 0;
        finalTotal['नूतनीकरण'] = 0;
      }
    }
  });

  Object.entries(countryMap).forEach(([country, states]: any) => {
    Object.entries(states).forEach(([state, districts]: any) => {
      Object.entries(districts).forEach(([district, records]: any[]) => {

        let totalData: any = {};
        this.subTypesName.forEach((b: any, i) => {
          if (b.isVisible) {
            let name = this.getKey(b.name);
            totalData[name + '_एकूण'] = 0;
            totalData[name + '_नवीन'] = 0;
            totalData[name + '_नूतनीकरण'] = 0;
            if (i === 0) {
              totalData['एकूण'] = 0;
              totalData['नवीन'] = 0;
              totalData['नूतनीकरण'] = 0;
            }
          }
        });

        let representativeMap = new Map<string, any>();
        let officeRepresentativeMap = new Map<string, any>();
        let unknownReps = new Map<string, any>();

        records.forEach((a: any) => {
          const name = this.getKey(a.subscription_type);
          const repKey = (a.rep_name || "Unknown").trim();
          const officeKey = (a.office_rep_name || "Unknown").trim();
          const amt = parseInt(a.total_amt);

          // Initialize representative data
          if (!representativeMap.has(repKey)) {
            representativeMap.set(repKey, {
              total_amt: 0,
              new_count: 0,
              renew_count: 0,
              taluka: a.rep_taluka || '',
              name: repKey
            });
          }

          const repData = representativeMap.get(repKey);
          this.subTypesName.forEach((b: any, i) => {
            if (b.isVisible) {
              let subName = this.getKey(b.name);
              repData[subName + '_एकूण'] ??= 0;
              repData[subName + '_नवीन'] ??= 0;
              repData[subName + '_नूतनीकरण'] ??= 0;
              if (i === 0) {
                repData['एकूण'] ??= 0;
                repData['नवीन'] ??= 0;
                repData['नूतनीकरण'] ??= 0;
              }
            }
          });

          // Update representative totals
          repData.total_amt += amt;
          repData.new_count += a.rcpt_type === 'New' ? 1 : 0;
          repData.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
          repData[name + '_एकूण'] += amt;
          repData[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
          repData[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
          repData['एकूण'] += amt;
          repData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
          repData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

          // Handle office rep mapping
          if (officeKey === "Unknown") {
            if (!unknownReps.has(repKey)) {
              unknownReps.set(repKey, { ...repData });
            }
          } else {
            if (!officeRepresentativeMap.has(officeKey)) {
              officeRepresentativeMap.set(officeKey, {
                total_amt: 0,
                new_count: 0,
                renew_count: 0,
                representatives: new Map<string, any>()
              });
            }

            const officeData = officeRepresentativeMap.get(officeKey);

            this.subTypesName.forEach((b: any, i) => {
              if (b.isVisible) {
                let subName = this.getKey(b.name);
                officeData[subName + '_एकूण'] ??= 0;
                officeData[subName + '_नवीन'] ??= 0;
                officeData[subName + '_नूतनीकरण'] ??= 0;
                if (i === 0) {
                  officeData['एकूण'] ??= 0;
                  officeData['नवीन'] ??= 0;
                  officeData['नूतनीकरण'] ??= 0;
                }
              }
            });

            // Update office representative totals
            officeData.total_amt += amt;
            officeData.new_count += a.rcpt_type === 'New' ? 1 : 0;
            officeData.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
            officeData[name + '_एकूण'] += amt;
            officeData[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            officeData[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
            officeData['एकूण'] += amt;
            officeData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
            officeData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

            // ✅ Add representative only once to correct office rep
            if (a.office_rep_name?.trim() === officeKey && a.rep_name?.trim() === repKey) {
              if (!officeData.representatives.has(repKey)) {
                officeData.representatives.set(repKey, { ...repData });
              }else {
                // ✅ Update existing representative data under the office rep
                const existingRep = officeData.representatives.get(repKey);
                existingRep.total_amt += amt;
                existingRep.new_count += a.rcpt_type === 'New' ? 1 : 0;
                existingRep.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;
                existingRep[name + '_एकूण'] += amt;
                existingRep[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
                existingRep[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
                existingRep['एकूण'] += amt;
                existingRep['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
                existingRep['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
              }

            }
          }

          // District and final totals
          totalData[name + '_एकूण'] += amt;
          totalData[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
          totalData[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
          totalData['एकूण'] += amt;
          totalData['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
          totalData['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

          finalTotal[name + '_एकूण'] += amt;
          finalTotal[name + '_नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
          finalTotal[name + '_नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;
          finalTotal['एकूण'] += amt;
          finalTotal['नवीन'] += a.rcpt_type === 'New' ? 1 : 0;
          finalTotal['नूतनीकरण'] += a.rcpt_type === 'Renew' ? 1 : 0;

          totalData['taluka'] = a.taluka;
          totalData['state'] = a.state;
          totalData['country'] = a.country;
          totalData['district_name'] = a.district_name;
          totalData['rep_taluka'] = a.rep_taluka;
        });

        // Convert maps to plain objects
        officeRepresentativeMap.forEach((data, key) => {
          data.representatives = Object.fromEntries([...data.representatives.entries()].sort());
        });

        totalData['representatives'] = Object.fromEntries(representativeMap);
        totalData['officeRepresentatives'] = Object.fromEntries(officeRepresentativeMap);
        totalData['unknownRepresentatives'] = Object.fromEntries(unknownReps);

        districts[district] = {
          records,
          finalData: totalData,
        };
      });
    });
  });

  const finalDataArray = Object.entries(countryMap).map(([key, value]) => ({ key, value }));
  finalDataArray.push({ key: 'finalData', value: finalTotal });
  this.finalData = finalDataArray;
  this.isLoading = false;
  console.log(this.finalData);
}


mergeRepresentativeData(target: any, source: any) {
  for (let key in source) {
    if (typeof source[key] === 'number') {
      target[key] = (target[key] || 0) + source[key];
    }
  }
}



  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section1');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


  //Main Report Method Use in all Printing Page
  show = false




printPage() {
  this.show = true;
  const printContent = document.getElementById('print-section1')?.outerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page {
                size: A3 landscape;
                margin: 10mm;
              }

              body {
                font-family: Arial, sans-serif;
                font-size: 12px;
                margin: 0;
                padding: 0;
                line-height: 1.4;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
                page-break-inside: avoid;
              }

              th, td {
                padding: 1px;
                border: 1px solid black;
                text-align: center;
                font-size: 12px;
                line-height: 1.2;
                word-break: break-word;
              }

              /* Make STATE column (left & right borders) lighter */
              td.state-col, th.state-col {
                border-left: 1px solid #ccc !important;
                border-right: 1px solid #ccc !important;
              }

              /* Make DISTRICT column (left border) lighter */
              td.district-col, th.district-col {
                border-left: 1px solid #ccc !important;
              }

              /* Prevent line breaks in rep + taluka column */
              td.rep-taluka {
                white-space: nowrap;
                text-overflow: ellipsis;
                max-width: 200px;
              }

              .noPrint {
                display: none !important;
              }

              div, tr, td, th, tbody, thead, tfoot {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
              }

              #print-section1 {
                page-break-after: avoid;
                break-after: avoid;
              }
            }
          </style>
        </head>
        <body>
          <div id="print-section1">
            ${printContent}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}




}
